<div *ngIf="!isLoading">
    <div style="margin-left: 80%;   margin-bottom: 2%;">
        <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary" [useExistingCss]="true"
            printSectionId="print-section" ngxPrint>
            print
        </button>
        <button *ngIf="isupdate == false" class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="saveAdvtInvoice()" mat-raised-button color="primary">
            Save
        </button>
        <button *ngIf="isupdate == true" class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="updateInvoice()" mat-raised-button color="primary">
            Update
        </button>
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
    <div id="print-section">
        <ng-container *ngFor="let showData of printShowData; let i=index">
            <div [ngStyle]="{'margin-top':i != 0 ? '45px' : '0px' }">
                <div class="container" style="margin: 0 15px;">
                    <div class="row botm height">
                        <div class="col-9 topheader bottom right">
                            <span class="fontBold">हिंदुस्थान प्रकाशन संस्था</span>
                            <span><span class="heading1">प्रशासकीय कार्यालय</span> - </span>
                            <span>116-119, पहिला मजला, शिल्पीन सेंटर, 40, गं. द. आंबेकर मार्ग, वडाला मुंबई -
                                400031</span>
                            <span>दूरध्वनी: ९९६७५७०५३१, Email:
                                vivekwkladvt&#64;gmail.com</span>
                        </div>
                        <div class="col-3 bottom flex">
                            <img src="../../../assets/img/brand/red.png" alt="" style=" width: 65% !important;
  height: 100px;
  /* aspect-ratio: 3/4; */
  object-fit: cover;
  color: #000;">
                        </div>
                    </div>
                    <div class="row taxheading bottom">
                        <div class="fontBold">
                            Tax Invoice / जाहिरात देयक
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 bottom right heading1">
                            Our GST No: 27AAATH0433Q1ZI
                        </div>
                        <div class="col-6 bottom heading1">
                            Advt Invoice No: {{ showData['invoice_no'] }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 right bottom heading1">
                            Our PAN No: AAATH0433Q
                        </div>
                        <div class="col-6 bottom heading1">
                            Advt Invoice Date: {{ date | date:"dd/MM/yyyy" }}
                        </div>
                    </div>
                    <div class="row botm height1">
                        <div class="col-7 bottom right flexbox">
                            <span class="heading1 alignment">Name: {{ showData['advt_name'] }}<span></span></span>
                            <span class="alignment">Address: {{ showData['address'] }}<span></span></span>
                            <span>State: {{ showData['state'] }}</span>
                            <span>Customer GST No: {{ showData['cust_gst_no'] }}</span>
                        </div>
                        <div class="col-5 bottom flexbox addpad" style="padding: 0px;">
                            <span class="flexbox bottom">
                                <!-- <span>Advt. Order No.: {{ showData['advt_order_no'] }}</span> -->
                                <span>RO No.: {{ showData['ro_no'] }} </span>

                                <span> RO date : {{ showData['ro_date'] }}</span>
                            </span>
                            <span class="">
                                <span>Client Name: {{ showData['cust_name'] }}</span>
                            </span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 bottom">माहे {{ date | date:"MMMM yyyy"}}, विवेक साप्ताहिक या प्रकाशनामध्ये
                            पुढील
                            तपशिलानुसार जाहिरात
                            प्रसिद्ध
                            करण्यात आली,
                            धन्यवाद!</div>
                    </div>
                    <div class="row">
                        <div class="col right bottom">आठवडे -</div>
                        <div class="col right bottom cent">1) पहिला</div>
                        <div class="col right bottom cent">2) दुसरा</div>
                        <div class="col right bottom cent">3) तिसरा</div>
                        <div class="col right bottom cent">4) चौथा</div>
                        <div class="col right bottom cent">5) पाचवा</div>
                        <div class="col bottom cent">रक्कम रुपये</div>
                    </div>
                    <div class="row">
                        <div class="col right bottom">अंकाचे नाव :</div>
                        <div class="col right bottom cent">{{ showData['firstweek']['issueName'] }}</div>
                        <div class="col right bottom cent">{{ showData['secondweek']['issueName'] }}</div>
                        <div class="col right bottom cent">{{ showData['thirdweek']['issueName'] }}</div>
                        <div class="col right bottom cent">{{ showData['fourthweek']['issueName'] }}</div>
                        <div class="col right bottom cent">{{ showData['fifthweek']['issueName'] }}</div>
                        <div class="col bottom"></div>
                    </div>
                    <div class="row">
                        <div class="col right bottom">अंक दिनांक :</div>
                        <div class="col right bottom cent">{{ showData['firstweek']['issue_date'] }}</div>
                        <div class="col right bottom cent">{{ showData['secondweek']['issue_date'] }}</div>
                        <div class="col right bottom cent">{{ showData['thirdweek']['issue_date'] }}</div>
                        <div class="col right bottom cent">{{ showData['fourthweek']['issue_date'] }}</div>
                        <div class="col right bottom cent">{{ showData['fifthweek']['issue_date'] }}</div>
                        <div class="col bottom"></div>
                    </div>

                    <div class="row">
                        <div class="col right bottom">जाहिरात आकार :</div>
                        <div class="col right bottom cent">{{ showData['firstweek']['advt_size'] }}</div>
                        <div class="col right bottom cent">{{ showData['secondweek']['advt_size'] }}</div>
                        <div class="col right bottom cent">{{ showData['thirdweek']['advt_size'] }}</div>
                        <div class="col right bottom cent">{{ showData['fourthweek']['advt_size'] }}</div>
                        <div class="col right bottom cent">{{ showData['fifthweek']['advt_size'] }}</div>
                        <div class="col bottom"></div>
                    </div>
                    <div class="row">
                        <div class="col right bottom">पृष्ठ क्र. :</div>
                        <div class="col right bottom cent">{{ showData['firstweek']['page_no'] }}</div>
                        <div class="col right bottom cent">{{ showData['secondweek']['page_no'] }}</div>
                        <div class="col right bottom cent">{{ showData['thirdweek']['page_no'] }}</div>
                        <div class="col right bottom cent">{{ showData['fourthweek']['page_no'] }}</div>
                        <div class="col right bottom cent">{{ showData['fifthweek']['page_no'] }}</div>
                        <div class="col bottom cent"></div>
                    </div>
                    <div class="row botm">
                        <div class="col right bottom">HSN / SAC :</div>
                        <div class="col right bottom rightside">{{ showData['firstweek']['hsn'] }}</div>
                        <div class="col right bottom rightside">{{ showData['secondweek']['hsn'] }}</div>
                        <div class="col right bottom rightside">{{ showData['thirdweek']['hsn'] }}</div>
                        <div class="col right bottom rightside">{{ showData['fourthweek']['hsn'] }}</div>
                        <div class="col right bottom rightside">{{ showData['fifthweek']['hsn'] }}</div>
                        <div class="col bottom rightside"></div>
                    </div>
                    <div class="row">
                        <div class="col right bottom">जाहिरात दर :</div>

                        <div class="col right bottom rightside">
                            {{ showData['firstweek']['total'] != 0 ? showData['firstweek']['total'] : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ showData['secondweek']['total'] != 0 ? showData['secondweek']['total'] : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ showData['thirdweek']['total'] != 0 ? showData['thirdweek']['total'] : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ showData['fourthweek']['total'] != 0 ? showData['fourthweek']['total'] : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ showData['fifthweek']['total'] != 0 ? showData['fifthweek']['total'] : '' }}
                        </div>

                        <div class="col bottom rightside">
                            {{ showData['total_amt']['total'] != 0 ? showData['total_amt']['total'] : '' }}
                        </div>
                    </div>

                    <div class="row">
                        <div class="col right bottom">सूट रु :</div>

                        <div class="col right bottom rightside">
                            {{ calculateDiscount(showData['firstweek']['dis'], showData['firstweek']['total']) != 0
                            ? calculateDiscount(showData['firstweek']['dis'], showData['firstweek']['total'])
                            : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ calculateDiscount(showData['secondweek']['dis'], showData['secondweek']['total']) != 0
                            ? calculateDiscount(showData['secondweek']['dis'], showData['secondweek']['total'])
                            : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ calculateDiscount(showData['thirdweek']['dis'], showData['thirdweek']['total']) != 0
                            ? calculateDiscount(showData['thirdweek']['dis'], showData['thirdweek']['total'])
                            : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ calculateDiscount(showData['fourthweek']['dis'], showData['fourthweek']['total']) != 0
                            ? calculateDiscount(showData['fourthweek']['dis'], showData['fourthweek']['total'])
                            : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ calculateDiscount(showData['fifthweek']['dis'], showData['fifthweek']['total']) != 0
                            ? calculateDiscount(showData['fifthweek']['dis'], showData['fifthweek']['total'])
                            : '' }}
                        </div>

                        <div class="col bottom rightside">
                            {{
                            (calculateDiscount(showData['firstweek']['dis'], showData['firstweek']['total']) +
                            calculateDiscount(showData['secondweek']['dis'], showData['secondweek']['total']) +
                            calculateDiscount(showData['thirdweek']['dis'], showData['thirdweek']['total']) +
                            calculateDiscount(showData['fourthweek']['dis'], showData['fourthweek']['total']) +
                            calculateDiscount(showData['fifthweek']['dis'], showData['fifthweek']['total'])) != 0
                            ? (calculateDiscount(showData['firstweek']['dis'], showData['firstweek']['total']) +
                            calculateDiscount(showData['secondweek']['dis'], showData['secondweek']['total']) +
                            calculateDiscount(showData['thirdweek']['dis'], showData['thirdweek']['total']) +
                            calculateDiscount(showData['fourthweek']['dis'], showData['fourthweek']['total']) +
                            calculateDiscount(showData['fifthweek']['dis'], showData['fifthweek']['total']))
                            : ''
                            }}
                        </div>
                    </div>

                    <!-- <div class="row">
                        <div class="col right bottom">निव्वळ रु:</div>
                        <div class="col right bottom rightside">{{ showData['firstweek']['total'] }}</div>
                        <div class="col right bottom rightside">{{ showData['secondweek']['total'] }}</div>
                        <div class="col right bottom rightside">{{ showData['thirdweek']['total'] }}</div>
                        <div class="col right bottom rightside">{{ showData['fourthweek']['total'] }}</div>
                        <div class="col right bottom rightside">{{ showData['fifthweek']['total'] }}</div>
                        <div class="col bottom rightside">{{ this.showData['total_amt']['total'] }}</div>
                    </div> -->
                    <div class="row">
                        <div class="col right bottom">निव्वळ रु :</div>

                        <div class="col right bottom rightside">
                            {{ (showData['firstweek']['total'] - calculateDiscount(showData['firstweek']['dis'],
                            showData['firstweek']['total'])) || '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ (showData['secondweek']['total'] - calculateDiscount(showData['secondweek']['dis'],
                            showData['secondweek']['total'])) || '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ (showData['thirdweek']['total'] - calculateDiscount(showData['thirdweek']['dis'],
                            showData['thirdweek']['total'])) || '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ (showData['fourthweek']['total'] - calculateDiscount(showData['fourthweek']['dis'],
                            showData['fourthweek']['total'])) || '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ (showData['fifthweek']['total'] - calculateDiscount(showData['fifthweek']['dis'],
                            showData['fifthweek']['total'])) || '' }}
                        </div>

                        <div class="col bottom rightside">
                            {{
                            ((showData['firstweek']['total'] - calculateDiscount(showData['firstweek']['dis'],
                            showData['firstweek']['total'])) +
                            (showData['secondweek']['total'] - calculateDiscount(showData['secondweek']['dis'],
                            showData['secondweek']['total'])) +
                            (showData['thirdweek']['total'] - calculateDiscount(showData['thirdweek']['dis'],
                            showData['thirdweek']['total'])) +
                            (showData['fourthweek']['total'] - calculateDiscount(showData['fourthweek']['dis'],
                            showData['fourthweek']['total'])) +
                            (showData['fifthweek']['total'] - calculateDiscount(showData['fifthweek']['dis'],
                            showData['fifthweek']['total']))) || ''
                            }}
                        </div>
                    </div>


                    <!-- <div class="row">
                        <div class="col right bottom">GST अगोदर</div>

                        <div class="col right bottom rightside">
                            {{
                            showData['gst_type'] === 'gstExclude' ?
                            parseNumber(showData['firstweek']['total']) :
                            parseNumber(showData['firstweek']['total']) -
                            (parseNumber(showData['firstweek']['cgst']) +
                            parseNumber(showData['firstweek']['sgst']) +
                            parseNumber(showData['firstweek']['igst']))
                            }}
                        </div>
                        <div class="col right bottom rightside">
                            {{
                            showData['gst_type'] === 'gstExclude' ?
                            parseNumber(showData['secondweek']['total']) :
                            parseNumber(showData['secondweek']['total']) -
                            (parseNumber(showData['secondweek']['cgst']) +
                            parseNumber(showData['secondweek']['sgst']) +
                            parseNumber(showData['secondweek']['igst']))
                            }}
                        </div>
                        <div class="col right bottom rightside">
                            {{
                            showData['gst_type'] === 'gstExclude' ?
                            parseNumber(showData['thirdweek']['total']) :
                            parseNumber(showData['thirdweek']['total']) -
                            (parseNumber(showData['thirdweek']['cgst']) +
                            parseNumber(showData['thirdweek']['sgst']) +
                            parseNumber(showData['thirdweek']['igst']))
                            }}
                        </div>
                        <div class="col right bottom rightside">
                            {{
                            showData['gst_type'] === 'gstExclude' ?
                            parseNumber(showData['fourthweek']['total']) :
                            parseNumber(showData['fourthweek']['total']) -
                            (parseNumber(showData['fourthweek']['cgst']) +
                            parseNumber(showData['fourthweek']['sgst']) +
                            parseNumber(showData['fourthweek']['igst']))
                            }}
                        </div>
                        <div class="col right bottom rightside">
                            {{
                            showData['gst_type'] === 'gstExclude' ?
                            parseNumber(showData['fifthweek']['total']) :
                            parseNumber(showData['fifthweek']['total']) -
                            (parseNumber(showData['fifthweek']['cgst']) +
                            parseNumber(showData['fifthweek']['sgst']) +
                            parseNumber(showData['fifthweek']['igst']))
                            }}
                        </div>

                        <div class="col bottom rightside">
                            {{
                            (showData['gst_type'] === 'gstExclude' ? parseNumber(showData['firstweek']['total']) :
                            parseNumber(showData['firstweek']['total']) -
                            (parseNumber(showData['firstweek']['cgst']) +
                            parseNumber(showData['firstweek']['sgst']) +
                            parseNumber(showData['firstweek']['igst']))) +

                            (showData['gst_type'] === 'gstExclude' ? parseNumber(showData['secondweek']['total']) :
                            parseNumber(showData['secondweek']['total']) -
                            (parseNumber(showData['secondweek']['cgst']) +
                            parseNumber(showData['secondweek']['sgst']) +
                            parseNumber(showData['secondweek']['igst']))) +

                            (showData['gst_type'] === 'gstExclude' ? parseNumber(showData['thirdweek']['total']) :
                            parseNumber(showData['thirdweek']['total']) -
                            (parseNumber(showData['thirdweek']['cgst']) +
                            parseNumber(showData['thirdweek']['sgst']) +
                            parseNumber(showData['thirdweek']['igst']))) +

                            (showData['gst_type'] === 'gstExclude' ? parseNumber(showData['fourthweek']['total']) :
                            parseNumber(showData['fourthweek']['total']) -
                            (parseNumber(showData['fourthweek']['cgst']) +
                            parseNumber(showData['fourthweek']['sgst']) +
                            parseNumber(showData['fourthweek']['igst']))) +

                            (showData['gst_type'] === 'gstExclude' ? parseNumber(showData['fifthweek']['total']) :
                            parseNumber(showData['fifthweek']['total']) -
                            (parseNumber(showData['fifthweek']['cgst']) +
                            parseNumber(showData['fifthweek']['sgst']) +
                            parseNumber(showData['fifthweek']['igst'])))
                            }}
                        </div>
                    </div> -->
                    <div class="row">
                        <div class="col right bottom">GST अगोदर</div>

                        <div class="col right bottom rightside">
                            {{ calculateNetAmount(showData['firstweek']) != 0 ?
                            calculateNetAmount(showData['firstweek']) : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ calculateNetAmount(showData['secondweek']) != 0 ?
                            calculateNetAmount(showData['secondweek']) : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ calculateNetAmount(showData['thirdweek']) != 0 ?
                            calculateNetAmount(showData['thirdweek']) : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ calculateNetAmount(showData['fourthweek']) != 0 ?
                            calculateNetAmount(showData['fourthweek']) : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ calculateNetAmount(showData['fifthweek']) != 0 ?
                            calculateNetAmount(showData['fifthweek']) : '' }}
                        </div>

                        <!-- Total Calculation -->
                        <div class="col bottom rightside">
                            {{
                            (calculateNetAmount(showData['firstweek']) +
                            calculateNetAmount(showData['secondweek']) +
                            calculateNetAmount(showData['thirdweek']) +
                            calculateNetAmount(showData['fourthweek']) +
                            calculateNetAmount(showData['fifthweek'])) != 0
                            ? (calculateNetAmount(showData['firstweek']) +
                            calculateNetAmount(showData['secondweek']) +
                            calculateNetAmount(showData['thirdweek']) +
                            calculateNetAmount(showData['fourthweek']) +
                            calculateNetAmount(showData['fifthweek']))
                            : ''
                            }}
                        </div>
                    </div>

                    <div class="row">
                        <div class="col right bottom">2.5 % CGST</div>

                        <div class="col right bottom rightside">
                            {{ showData['firstweek']['cgst'] != 0 ? showData['firstweek']['cgst'] : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ showData['secondweek']['cgst'] != 0 ? showData['secondweek']['cgst'] : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ showData['thirdweek']['cgst'] != 0 ? showData['thirdweek']['cgst'] : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ showData['fourthweek']['cgst'] != 0 ? showData['fourthweek']['cgst'] : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ showData['fifthweek']['cgst'] != 0 ? showData['fifthweek']['cgst'] : '' }}
                        </div>

                        <div class="col bottom rightside">
                            {{
                            (parseNumber(showData['firstweek']['cgst'] || 0) +
                            parseNumber(showData['secondweek']['cgst'] || 0) +
                            parseNumber(showData['thirdweek']['cgst'] || 0) +
                            parseNumber(showData['fourthweek']['cgst'] || 0) +
                            parseNumber(showData['fifthweek']['cgst'] || 0)) != 0
                            ? (parseNumber(showData['firstweek']['cgst'] || 0) +
                            parseNumber(showData['secondweek']['cgst'] || 0) +
                            parseNumber(showData['thirdweek']['cgst'] || 0) +
                            parseNumber(showData['fourthweek']['cgst'] || 0) +
                            parseNumber(showData['fifthweek']['cgst'] || 0))
                            : ''
                            }}
                        </div>
                    </div>

                    <div class="row">
                        <div class="col right bottom">2.5 % SGST</div>

                        <div class="col right bottom rightside">
                            {{ showData['firstweek']['sgst'] != 0 ? showData['firstweek']['sgst'] : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ showData['secondweek']['sgst'] != 0 ? showData['secondweek']['sgst'] : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ showData['thirdweek']['sgst'] != 0 ? showData['thirdweek']['sgst'] : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ showData['fourthweek']['sgst'] != 0 ? showData['fourthweek']['sgst'] : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ showData['fifthweek']['sgst'] != 0 ? showData['fifthweek']['sgst'] : '' }}
                        </div>

                        <div class="col bottom rightside">
                            {{
                            (parseNumber(showData['firstweek']['sgst'] || 0) +
                            parseNumber(showData['secondweek']['sgst'] || 0) +
                            parseNumber(showData['thirdweek']['sgst'] || 0) +
                            parseNumber(showData['fourthweek']['sgst'] || 0) +
                            parseNumber(showData['fifthweek']['sgst'] || 0)) != 0
                            ? (parseNumber(showData['firstweek']['sgst'] || 0) +
                            parseNumber(showData['secondweek']['sgst'] || 0) +
                            parseNumber(showData['thirdweek']['sgst'] || 0) +
                            parseNumber(showData['fourthweek']['sgst'] || 0) +
                            parseNumber(showData['fifthweek']['sgst'] || 0))
                            : ''
                            }}
                        </div>
                    </div>

                    <div class="row">
                        <div class="col right bottom">5 % IGST</div>

                        <div class="col right bottom rightside">
                            {{ showData['firstweek']['igst'] != 0 ? showData['firstweek']['igst'] : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ showData['secondweek']['igst'] != 0 ? showData['secondweek']['igst'] : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ showData['thirdweek']['igst'] != 0 ? showData['thirdweek']['igst'] : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ showData['fourthweek']['igst'] != 0 ? showData['fourthweek']['igst'] : '' }}
                        </div>

                        <div class="col right bottom rightside">
                            {{ showData['fifthweek']['igst'] != 0 ? showData['fifthweek']['igst'] : '' }}
                        </div>

                        <div class="col bottom rightside">
                            {{
                            (parseNumber(showData['firstweek']['igst'] || 0) +
                            parseNumber(showData['secondweek']['igst'] || 0) +
                            parseNumber(showData['thirdweek']['igst'] || 0) +
                            parseNumber(showData['fourthweek']['igst'] || 0) +
                            parseNumber(showData['fifthweek']['igst'] || 0)) != 0
                            ? (parseNumber(showData['firstweek']['igst'] || 0) +
                            parseNumber(showData['secondweek']['igst'] || 0) +
                            parseNumber(showData['thirdweek']['igst'] || 0) +
                            parseNumber(showData['fourthweek']['igst'] || 0) +
                            parseNumber(showData['fifthweek']['igst'] || 0))
                            : ''
                            }}
                        </div>
                    </div>

                    <div class="row botm">
                        <div class="col right bottom">Round Off.</div>

                        <div class="col right bottom rightside">
                            {{
                            (+calculateNetAmount(showData['firstweek']) +
                            (+showData['firstweek']['cgst']) +
                            (+showData['firstweek']['sgst']) +
                            (+showData['firstweek']['igst'])) != 0
                            ? (+calculateNetAmount(showData['firstweek']) +
                            (+showData['firstweek']['cgst']) +
                            (+showData['firstweek']['sgst']) +
                            (+showData['firstweek']['igst']))
                            : ''
                            }}
                        </div>

                        <div class="col right bottom rightside">
                            {{
                            (+calculateNetAmount(showData['secondweek']) +
                            (+showData['secondweek']['cgst']) +
                            (+showData['secondweek']['sgst']) +
                            (+showData['secondweek']['igst'])) != 0
                            ? (+calculateNetAmount(showData['secondweek']) +
                            (+showData['secondweek']['cgst']) +
                            (+showData['secondweek']['sgst']) +
                            (+showData['secondweek']['igst']))
                            : ''
                            }}
                        </div>

                        <div class="col right bottom rightside">
                            {{
                            (+calculateNetAmount(showData['thirdweek']) +
                            (+showData['thirdweek']['cgst']) +
                            (+showData['thirdweek']['sgst']) +
                            (+showData['thirdweek']['igst'])) != 0
                            ? (+calculateNetAmount(showData['thirdweek']) +
                            (+showData['thirdweek']['cgst']) +
                            (+showData['thirdweek']['sgst']) +
                            (+showData['thirdweek']['igst']))
                            : ''
                            }}
                        </div>

                        <div class="col right bottom rightside">
                            {{
                            (+calculateNetAmount(showData['fourthweek']) +
                            (+showData['fourthweek']['cgst']) +
                            (+showData['fourthweek']['sgst']) +
                            (+showData['fourthweek']['igst'])) != 0
                            ? (+calculateNetAmount(showData['fourthweek']) +
                            (+showData['fourthweek']['cgst']) +
                            (+showData['fourthweek']['sgst']) +
                            (+showData['fourthweek']['igst']))
                            : ''
                            }}
                        </div>

                        <div class="col right bottom rightside">
                            {{
                            (+calculateNetAmount(showData['fifthweek']) +
                            (+showData['fifthweek']['cgst']) +
                            (+showData['fifthweek']['sgst']) +
                            (+showData['fifthweek']['igst'])) != 0
                            ? (+calculateNetAmount(showData['fifthweek']) +
                            (+showData['fifthweek']['cgst']) +
                            (+showData['fifthweek']['sgst']) +
                            (+showData['fifthweek']['igst']))
                            : ''
                            }}
                        </div>

                        <!-- Total Calculation -->
                        <div class="col bottom rightside">
                            {{
                            (parseNumber(calculateNetAmount(showData['firstweek'])) +
                            parseNumber(showData['firstweek']['cgst']) +
                            parseNumber(showData['firstweek']['sgst']) +
                            parseNumber(showData['firstweek']['igst']) +
                            parseNumber(calculateNetAmount(showData['secondweek'])) +
                            parseNumber(showData['secondweek']['cgst']) +
                            parseNumber(showData['secondweek']['sgst']) +
                            parseNumber(showData['secondweek']['igst']) +
                            parseNumber(calculateNetAmount(showData['thirdweek'])) +
                            parseNumber(showData['thirdweek']['cgst']) +
                            parseNumber(showData['thirdweek']['sgst']) +
                            parseNumber(showData['thirdweek']['igst']) +
                            parseNumber(calculateNetAmount(showData['fourthweek'])) +
                            parseNumber(showData['fourthweek']['cgst']) +
                            parseNumber(showData['fourthweek']['sgst']) +
                            parseNumber(showData['fourthweek']['igst']) +
                            parseNumber(calculateNetAmount(showData['fifthweek'])) +
                            parseNumber(showData['fifthweek']['cgst']) +
                            parseNumber(showData['fifthweek']['sgst']) +
                            parseNumber(showData['fifthweek']['igst'])
                            ) != 0
                            ? (parseNumber(calculateNetAmount(showData['firstweek'])) +
                            parseNumber(showData['firstweek']['cgst']) +
                            parseNumber(showData['firstweek']['sgst']) +
                            parseNumber(showData['firstweek']['igst']) +
                            parseNumber(calculateNetAmount(showData['secondweek'])) +
                            parseNumber(showData['secondweek']['cgst']) +
                            parseNumber(showData['secondweek']['sgst']) +
                            parseNumber(showData['secondweek']['igst']) +
                            parseNumber(calculateNetAmount(showData['thirdweek'])) +
                            parseNumber(showData['thirdweek']['cgst']) +
                            parseNumber(showData['thirdweek']['sgst']) +
                            parseNumber(showData['thirdweek']['igst']) +
                            parseNumber(calculateNetAmount(showData['fourthweek'])) +
                            parseNumber(showData['fourthweek']['cgst']) +
                            parseNumber(showData['fourthweek']['sgst']) +
                            parseNumber(showData['fourthweek']['igst']) +
                            parseNumber(calculateNetAmount(showData['fifthweek'])) +
                            parseNumber(showData['fifthweek']['cgst']) +
                            parseNumber(showData['fifthweek']['sgst']) +
                            parseNumber(showData['fifthweek']['igst']))
                            : ''
                            }}
                        </div>
                    </div>

                    <div class="row botm">
                        <div class="col right bottom heading1">Total</div>

                        <div class="col right bottom rightside">
                            {{
                            (+calculateNetAmount(showData['firstweek']) +
                            (+showData['firstweek']['cgst']) +
                            (+showData['firstweek']['sgst']) +
                            (+showData['firstweek']['igst'])) != 0
                            ? (+calculateNetAmount(showData['firstweek']) +
                            (+showData['firstweek']['cgst']) +
                            (+showData['firstweek']['sgst']) +
                            (+showData['firstweek']['igst']))
                            : ''
                            }}
                        </div>

                        <div class="col right bottom rightside">
                            {{
                            (+calculateNetAmount(showData['secondweek']) +
                            (+showData['secondweek']['cgst']) +
                            (+showData['secondweek']['sgst']) +
                            (+showData['secondweek']['igst'])) != 0
                            ? (+calculateNetAmount(showData['secondweek']) +
                            (+showData['secondweek']['cgst']) +
                            (+showData['secondweek']['sgst']) +
                            (+showData['secondweek']['igst']))
                            : ''
                            }}
                        </div>

                        <div class="col right bottom rightside">
                            {{
                            (+calculateNetAmount(showData['thirdweek']) +
                            (+showData['thirdweek']['cgst']) +
                            (+showData['thirdweek']['sgst']) +
                            (+showData['thirdweek']['igst'])) != 0
                            ? (+calculateNetAmount(showData['thirdweek']) +
                            (+showData['thirdweek']['cgst']) +
                            (+showData['thirdweek']['sgst']) +
                            (+showData['thirdweek']['igst']))
                            : ''
                            }}
                        </div>

                        <div class="col right bottom rightside">
                            {{
                            (+calculateNetAmount(showData['fourthweek']) +
                            (+showData['fourthweek']['cgst']) +
                            (+showData['fourthweek']['sgst']) +
                            (+showData['fourthweek']['igst'])) != 0
                            ? (+calculateNetAmount(showData['fourthweek']) +
                            (+showData['fourthweek']['cgst']) +
                            (+showData['fourthweek']['sgst']) +
                            (+showData['fourthweek']['igst']))
                            : ''
                            }}
                        </div>

                        <div class="col right bottom rightside">
                            {{
                            (+calculateNetAmount(showData['fifthweek']) +
                            (+showData['fifthweek']['cgst']) +
                            (+showData['fifthweek']['sgst']) +
                            (+showData['fifthweek']['igst'])) != 0
                            ? (+calculateNetAmount(showData['fifthweek']) +
                            (+showData['fifthweek']['cgst']) +
                            (+showData['fifthweek']['sgst']) +
                            (+showData['fifthweek']['igst']))
                            : ''
                            }}
                        </div>

                        <div class="col bottom rightside">
                            {{
                            (parseNumber(calculateNetAmount(showData['firstweek'])) +
                            parseNumber(showData['firstweek']['cgst']) +
                            parseNumber(showData['firstweek']['sgst']) +
                            parseNumber(showData['firstweek']['igst']) +
                            parseNumber(calculateNetAmount(showData['secondweek'])) +
                            parseNumber(showData['secondweek']['cgst']) +
                            parseNumber(showData['secondweek']['sgst']) +
                            parseNumber(showData['secondweek']['igst']) +
                            parseNumber(calculateNetAmount(showData['thirdweek'])) +
                            parseNumber(showData['thirdweek']['cgst']) +
                            parseNumber(showData['thirdweek']['sgst']) +
                            parseNumber(showData['thirdweek']['igst']) +
                            parseNumber(calculateNetAmount(showData['fourthweek'])) +
                            parseNumber(showData['fourthweek']['cgst']) +
                            parseNumber(showData['fourthweek']['sgst']) +
                            parseNumber(showData['fourthweek']['igst']) +
                            parseNumber(calculateNetAmount(showData['fifthweek'])) +
                            parseNumber(showData['fifthweek']['cgst']) +
                            parseNumber(showData['fifthweek']['sgst']) +
                            parseNumber(showData['fifthweek']['igst'])
                            ) != 0
                            ? ((parseNumber(calculateNetAmount(showData['firstweek'])) +
                            parseNumber(showData['firstweek']['cgst']) +
                            parseNumber(showData['firstweek']['sgst']) +
                            parseNumber(showData['firstweek']['igst']) +
                            parseNumber(calculateNetAmount(showData['secondweek'])) +
                            parseNumber(showData['secondweek']['cgst']) +
                            parseNumber(showData['secondweek']['sgst']) +
                            parseNumber(showData['secondweek']['igst']) +
                            parseNumber(calculateNetAmount(showData['thirdweek'])) +
                            parseNumber(showData['thirdweek']['cgst']) +
                            parseNumber(showData['thirdweek']['sgst']) +
                            parseNumber(showData['thirdweek']['igst']) +
                            parseNumber(calculateNetAmount(showData['fourthweek'])) +
                            parseNumber(showData['fourthweek']['cgst']) +
                            parseNumber(showData['fourthweek']['sgst']) +
                            parseNumber(showData['fourthweek']['igst']) +
                            parseNumber(calculateNetAmount(showData['fifthweek'])) +
                            parseNumber(showData['fifthweek']['cgst']) +
                            parseNumber(showData['fifthweek']['sgst']) +
                            parseNumber(showData['fifthweek']['igst'])) | numberWithoutCommas)
                            : ''
                            }}
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 bottom">Invoice Total ( In Words) : {{getTotalAmtInWords(showData)}}</div>
                    </div>
                    <!-- <div class="row">
                        <div class="col-12 bottom"></div>
                    </div> -->
                    <div class="row">
                        <div class="col-8 right bottom heading1">
                            Bank Details -
                        </div>
                        <div class="col-4 bottom spacebet"><span>मागील बाकी रु. :</span><span>{{
                                showData['balance_amt_by_name']
                                }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8 right bottom">
                            A/C Name - HINDUSTAN PRAKASHAN SANSTHA
                        </div>
                        <div class="col-4 bottom spacebet"><span>देयक रक्कम :</span><span>{{
                                (parseNumber(calculateNetAmount(showData['firstweek'])) +
                                parseNumber(showData['firstweek']['cgst']) + parseNumber(showData['firstweek']['sgst'])
                                + parseNumber(showData['firstweek']['igst'])) +
                                (parseNumber(calculateNetAmount(showData['secondweek'])) +
                                parseNumber(showData['secondweek']['cgst']) +
                                parseNumber(showData['secondweek']['sgst']) +
                                parseNumber(showData['secondweek']['igst'])) +
                                (parseNumber(calculateNetAmount(showData['thirdweek'])) +
                                parseNumber(showData['thirdweek']['cgst']) + parseNumber(showData['thirdweek']['sgst'])
                                + parseNumber(showData['thirdweek']['igst'])) +
                                (parseNumber(calculateNetAmount(showData['fourthweek'])) +
                                parseNumber(showData['fourthweek']['cgst']) +
                                parseNumber(showData['fourthweek']['sgst']) +
                                parseNumber(showData['fourthweek']['igst'])) +
                                (parseNumber(calculateNetAmount(showData['fifthweek'])) +
                                parseNumber(showData['fifthweek']['cgst']) + parseNumber(showData['fifthweek']['sgst'])
                                + parseNumber(showData['fifthweek']['igst'])) | numberWithoutCommas
                                }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8 right bottom">
                            <div style="display: flex; align-items: stretch; height: 100%;">
                                <div style="padding: 2px 5px; display: flex; align-items: center;">A/C No. - 20109800154
                                </div>
                                <div style="width: 1px; background-color: black; margin-left: 70px; margin-right: 8px;">
                                </div>
                                <div style="padding: 2px 5px; display: flex; align-items: center;">IFSC No. -
                                    MAHB0000318</div>
                            </div>
                        </div>

                        <div class="col-4 bottom spacebet"><span>एकूण येणे रु. :</span><span>{{
                                (parseNumber(calculateNetAmount(showData['firstweek'])) +
                                parseNumber(showData['firstweek']['cgst']) + parseNumber(showData['firstweek']['sgst'])
                                + parseNumber(showData['firstweek']['igst'])) +
                                (parseNumber(calculateNetAmount(showData['secondweek'])) +
                                parseNumber(showData['secondweek']['cgst']) +
                                parseNumber(showData['secondweek']['sgst']) +
                                parseNumber(showData['secondweek']['igst'])) +
                                (parseNumber(calculateNetAmount(showData['thirdweek'])) +
                                parseNumber(showData['thirdweek']['cgst']) + parseNumber(showData['thirdweek']['sgst'])
                                + parseNumber(showData['thirdweek']['igst'])) +
                                (parseNumber(calculateNetAmount(showData['fourthweek'])) +
                                parseNumber(showData['fourthweek']['cgst']) +
                                parseNumber(showData['fourthweek']['sgst']) +
                                parseNumber(showData['fourthweek']['igst'])) +
                                (parseNumber(calculateNetAmount(showData['fifthweek'])) +
                                parseNumber(showData['fifthweek']['cgst']) + parseNumber(showData['fifthweek']['sgst'])
                                + parseNumber(showData['fifthweek']['igst'])) | numberWithoutCommas
                                }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8 right bottom">IFSC No. - MAHB0000318</div>
                        <div class="col-4"></div>
                    </div>
                    <div class="row">
                        <div class="col-8 right bottom">
                            Bank Name - Bank of Maharashtra
                        </div>
                        <div class="col-4"></div>
                    </div>
                    <div class="row">
                        <div class="col-8 right bottom">
                            Bank Branch - Prabhadevi, Mumbai - 400025
                        </div>
                        <div class="col-4 bottom"></div>
                    </div>
                    <div class="row">
                        <div class="col-8 right flexbox">
                            <span>सूचना : </span>
                            <span class="alignment">1) <span>जाहिरात रक्कमेचा धनादेश 'हिंदुस्थान प्रकाशन संस्था' या
                                    नावाने
                                    पाठवावा.</span></span>
                            <span class="alignment">2) <span>जाहिरात देयकाबाबत काही तक्रार असल्यास हे देयक मिळाल्यापासून
                                    १०
                                    दिवसांच्या आत
                                    कार्यालयात संपर्क करावा.</span></span>
                            <span class="alignment">3) <span>चूक/भूल द्यावी घ्यावी</span></span>
                        </div>
                        <div class="col-4 flexadd">
                            <span class="fontBold">हिंदुस्थान प्रकाशन संस्था</span>
                            <img src="../../../assets/img/brand/AK_sign1.png" alt="Signature" />
                            <span>जाहिरात विभागाकरिता</span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
<div *ngIf="isLoading" class="main-loading">
    <span class="loader"></span>
    <p>Loading...</p>
</div>